// @ts-strict-ignore
import {AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, output} from "@angular/core";
import {
	animate,
	animateChild,
	animation,
	group,
	keyframes,
	query,
	state,
	style,
	transition,
	trigger,
	useAnimation,
} from "@angular/animations";
import {IAnimationOptions} from "angular-animations/common/interfaces";
import {zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";
import {NotificationService, SimUtilityService} from "@services";
import {Translations} from "@translations";

const zoomIn = () =>
	animation(
		group([
			animate(
				"{{duration}}ms {{delay}}ms",
				keyframes([
					style({opacity: 0, easing: "ease", offset: 0}),
					style({opacity: 1, easing: "ease", offset: 0.5}),
					style({opacity: 1, easing: "ease", offset: 1}),
				]),
			),
			animate(
				"{{duration}}ms {{delay}}ms",
				keyframes([
					style({
						visibility: "visible",
						transform: "scale3d(0.3, 0.3, 0.3)",
						easing: "ease",
						offset: 0,
					}),
					style({
						transform: "scale3d(1, 1, 1)",
						easing: "ease",
						offset: 1,
					}),
				]),
			),
		]),
	);

export function useAnimationIncludingChildrenCustom(animation, options) {
	return [
		...(options && options.animateChildren === "before" ? [query("@*", animateChild(), {optional: true})] : []),
		group([
			useAnimation(animation),
			...(!options || !options.animateChildren || options.animateChildren === "together"
				? [query("@*", animateChild(), {optional: true})]
				: []),
		]),
		...(options && options.animateChildren === "after" ? [query("@*", animateChild(), {optional: true})] : []),
	];
}

const zoomInOptions: IAnimationOptions = {
	duration: 175,
	delay: 0,
};

type NullValueDisplayOptions = {
	text: string;
	substituteValue: any;
};

@Component({
	selector: "sim-admin-settings-enum-multiple-select-to-label-transformer",
	templateUrl: "./sim-admin-settings-enum-multiple-select-to-label-transformer.component.html",
	styleUrls: ["./sim-admin-settings-enum-multiple-select-to-label-transformer.component.scss"],
	animations: [
		zoomInOnEnterAnimation({duration: 175}),
		zoomOutOnLeaveAnimation({duration: 175}),
		trigger("flyInOut", [
			state("in", style({transform: "translateX(0)"})),
			transition("void => *", [style({visibility: "hidden"}), ...useAnimationIncludingChildrenCustom(zoomIn(), zoomInOptions)], {
				params: {
					delay: (zoomInOptions && zoomInOptions.delay) || 0,
					duration: zoomInOptions && zoomInOptions.duration,
				},
			}),
			transition("* => void", [animate(0, style({transform: "translateX(100%)"}))]),
		]),
	],
	standalone: false,
})
export class SimAdminSettingsEnumMultipleSelectToLabelTransformerComponent implements OnInit, AfterViewInit, OnChanges {
	T = Translations;

	@Input() inEditMode: boolean = false;
	@Input() labelText: string;
	@Input() selectedValue: any;
	@Input() enum: any;

	selectedStringValues: string[];
	selectableValues: string[];

	@Input() compareWithFunction: (obj1: string, obj2: string) => boolean = (_, __) => {
		return true;
	};

	@Input() getDisplayValue: (element: string) => string = (_) => {
		return "";
	};

	valueHasChanged = output<any>();

	load_completed = false;
	@Input() usingStringValues: boolean = true;
	@Input() nullValueDisplayOptions: NullValueDisplayOptions;

	constructor(
		private _simNotificationService: NotificationService,
		public _simUtilltyServiceInjection: SimUtilityService,
	) {}

	ngOnInit(): void {}

	ngAfterViewInit(): void {
		this.load_completed = true;
	}

	handleStringModelChange(values: string[]) {
		//this.selectedValue = values;
		this.valueHasChanged.emit(this.stringToEnum(values));
	}

	public enumValueToString(value): string[] {
		let values: string[] = [];
		for (const numberValue of SimUtilityService.getValuesOfEnum(this.enum)) {
			if (numberValue && (value | numberValue) === value) {
				values.push(this.enum[numberValue]);
			}
		}
		return values;
	}
	public stringToEnum(values: string[]) {
		let e;
		for (const value of values) {
			e = e | this.enum[value];
		}
		return e;
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes["selectedValue"]) {
			this.selectedStringValues = this.enumValueToString(this.selectedValue);
		}
		if (changes["enum"]) {
			this.selectableValues = SimUtilityService.getStringValuesOfEnum(this.enum);
		}
	}
}
